module.exports = __webpack_public_path__ + "static/media/ECDMPortal.51fdaa7b.png";